import { parseCliAuthorizationView, parseCliGrantList, parseCliRevoked } from '@drama/contracts/platform'

/** Website session only: CLI credentials cannot approve or manage grants. */
export function createCliAuthorizationApi(transport) {
  const devicePath = code => `/api/cli/authorizations/${encodeURIComponent(code)}`
  return {
    inspect(code) { return transport.request('GET', devicePath(code), { parse: parseCliAuthorizationView }) },
    decide(code, decision) { return transport.request('POST', `${devicePath(code)}/decision`, { body: { decision }, parse: parseCliAuthorizationView }) },
    list() { return transport.request('GET', '/api/cli/grants', { parse: parseCliGrantList }) },
    revoke(id) { return transport.request('DELETE', `/api/cli/grants/${encodeURIComponent(id)}`, { parse: parseCliRevoked }) },
  }
}
